import Layout from '@/layout/index.vue'
import Register from '@/views/register/Register.vue'
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// 解决路由重复导航报错和导航取消报错
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated' && err.name !== 'NavigationCancelled') {
      return Promise.reject(err)
    }
  })
}

VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated' && err.name !== 'NavigationCancelled') {
      return Promise.reject(err)
    }
  })
}

const routes = [
  // {
  //   path: '/register',
  //   name: 'Register',
  //   component: Register,
  //   hidden: true
  // },

  {
    path: '/',
    component: Layout,
    redirect: '/home',
    children: [
      {
        path: 'home',
        name: 'Home',
        component: () => import('@/views/Home.vue'),
        meta: { title: '首页' }
      },
      {
        path: 'supply',
        name: 'Supply',
        component: () => import('@/views/supply/index.vue'),
        meta: { title: '供应信息' }
      },
      {
        path: 'supply/detail/:id',
        name: 'SupplyDetail',
        component: () => import('@/views/supply/detail.vue'),
        meta: {
          title: '供应详情',
          activeMenu: '/supply' // 激活父级菜单
        }
      },
      {
        path: 'purchase',
        name: 'Purchase',
        component: () => import('@/views/purchase/index.vue'),
        meta: { title: '求购信息' }
      },
      {
        path: 'purchase/detail/:id',
        name: 'PurchaseDetail',
        component: () => import('@/views/purchase/detail.vue'),
        meta: {
          title: '求购详情',
          activeMenu: '/purchase' // 激活父级菜单
        }
      },
      {
        path: 'price',
        name: 'Price',
        component: () => import('@/views/price/index.vue'),
        meta: { title: '市场价格' }
      },
      {
        path: 'merchants',
        name: 'Merchants',
        component: () => import('@/views/merchants/index.vue'),
        meta: { title: '优质商户' }
      },
      {
        path: 'merchants/detail/:id',
        name: 'MerchantDetail',
        component: () => import('@/views/merchants/detail.vue'),
        meta: {
          title: '商户详情',
          activeMenu: '/merchants' // 激活父级菜单
        }
      },
      {
        path: 'publish',
        name: 'Publish',
        component: () => import('@/views/publish/index.vue'),
        meta: { title: '发布信息' }
      },
      {
        path: 'news',
        name: 'News',
        component: () => import('@/views/news/index.vue'),
        meta: { title: '平台公告' }
      },
      {
        path: 'news/detail/:id',
        name: 'NewsDetail', // 建议改为大写 N，保持命名一致性
        component: () => import('@/views/news/detail.vue'),
        meta: {
          title: '公告详情',
          activeMenu: '/news' // 激活父级菜单
        }
      },
      {
        path: 'feedback',
        name: 'Feedback',
        component: () => import('@/views/feedback/index.vue'),
        meta: { title: '意见收集' }
      },
      {
        path: 'profile',
        name: 'Profile',
        component: () => import('@/views/profile/index.vue'),
        meta: {
          title: '个人中心',
          activeMenu: null // 不激活任何菜单
        }
      },

      {
        path: 'register',
        name: 'Register',
        component: () => import('@/views/register/Register.vue'),
        meta: {
          title: '注册',
          activeMenu: null // 不激活任何菜单
        }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,

  scrollBehavior(to, from, savedPosition) {
    // 如果是浏览器前进 / 后退
    if (savedPosition) {
      return savedPosition
    }
    // 默认跳转到顶部
    return { x: 0, y: 0 }
  }
})

export default router
